import { getTierForGateQuery } from '../api/query';
import type { Gate, Context, Tier } from '../types';

export async function getTierForGate(gate: Gate, context: Context): Promise<Tier> {
  const data = await getTierForGateQuery(context);

  return data.gates[gate];
}

export async function prefetchTiers(context: Context): Promise<void> {
  getTierForGateQuery(context);
}
